<template>
  <bg-modal
    :value="isOpen"
    title="Yakin menghapus transaksi?"
    description="Transaksi yang dihapus tidak dapat dikembalikan."
    desktop-size="sm"
    :closable="false"
    :close-on-click-backdrop="false"
    @close="closeModal"
  >
    <template #footer>
      <div class="flex justify-end">
        <bg-button
          :loading="isLoading"
          variant="primary"
          class="mr-16"
          @click="deleteTransaksi"
          >Hapus</bg-button
        >
        <bg-button @click="closeModal">Batal</bg-button>
      </div>
    </template>
  </bg-modal>
</template>

<script>
import { BgModal, BgButton } from 'bangul-vue';
import detailTransferApi from '@admin_endpoints/detail-transfer';

export default {
  name: 'DeleteTransaksiConfirmModal',

  components: {
    BgModal,
    BgButton,
  },

  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    invoiceId: {
      type: [String, Number],
      default: null,
    },
  },

  data() {
    return {
      isLoading: false,
    };
  },

  computed: {
    approvalId() {
      return this.$route.params.approval_id;
    },
  },

  methods: {
    closeModal() {
      this.$emit('update:isOpen', false);
      this.$emit('update:invoiceId', null);
    },

    async deleteTransaksi() {
      if (this.invoiceId !== null) {
        this.isLoading = true;

        try {
          await detailTransferApi.deleteInvoice(
            this.approvalId,
            this.invoiceId
          );

          this.$emit('action-success-delete');
          this.$toast.show('Transaksi berhasil dihapus');
        } catch (error) {
          const errorMessage =
            error?.response?.data.issue?.message ||
            'Gagal saat menghapus transaksi.';

          this.$toast.show(errorMessage);
        } finally {
          this.isLoading = false;
          this.closeModal();
        }
      }
    },
  },
};
</script>
